import axios from "axios";
import { apiURL } from "./constants";


//Get dashboard data
export async function getDashboard() {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.get(`${apiURL}/api/dashboard/analytics/`,
        {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }
    ).catch(error => {
        console.error('There was an error!', error);
        throw error;
    });
    return response;
}